import * as z from 'zod'

export const updatePasswordSchema = z
  .object({
    current_password: z.string(),
    new_password: z.string(),
    new_password_confirmation: z.string(),
  })
  .refine(
    ({ new_password, new_password_confirmation }) =>
      new_password === new_password_confirmation,
    { path: ['new_password_confirmation'] },
  )

export type UpdatePasswordDto = z.infer<typeof updatePasswordSchema>
